import $ from 'jquery';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://shilo-clinique.appligestion.com/style.css',
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    ]
}

Vue.use(VueHtmlToPaper, options);

export default {
    name: 'caisse-sortie-bon',
    components: {},
    props: [],
    data () {
        return {

        }
    },
    computed: {

    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);
    },
    methods: {
        printBonSortie() {
            this.$htmlToPaper('to_print')
        }
    }
}


